import React, { useState, useRef, useEffect } from "react";
import { Icon } from "semantic-ui-react";
import NoData from "../../../../../Dashboard/Charts/NoData/NoData";
import moment from "moment";
import { ReactComponent as MoreOptions } from "../../../../../../../assets/svg/menu.svg";
import ChartOptionsSidebar from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/ChartOptionsSidebar";
import ChartName from "../../../../../Dashboard/Charts/ChartName";
import DeleteWidget from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../../../assets/svg/settings.svg";
import { ChartFilterIcon } from "../../../../../Dashboard/Charts/ChartFilterOptions";
import { ReactComponent as MiniMize } from "../../../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../../../assets/svg/zoom_out_map.svg";
import { ReactComponent as ArrowIcon } from "../../../../../../../assets/svg/chevron.svg";

import FacebookIcon from "../../../../../../../assets/svg/facebook-icon.svg";
import InstagramIcon from "../../../../../../../assets/svg/instagram.svg";
import TwitterIcon from "../../../../../../../assets/svg/twitter-logo.svg";
import TiktokIcon from "../../../../../../../assets/svg/tiktok-icon.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import FBIntervalSelector from "../../../../../FbInsights/FBIntervalSelector";
// import RecentPost from "./RecentPost";
// import "./RecentPosts.scss";
// import CompetitorSelector from "./CompetitorSelector";

import CustomDropdown from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/CustomDropdown";
import Loading from "../../../InstagramInsights/components/Loading/Loading";
import CompPageSelector from "../CompetitorRecentPosts/CompPageSelector";
import CompetitorByEngagementChart from "./CompetitorByEngagementChart";
import CustomCheckBox from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/CustomCheckBox";
import DownloadChart from "../../../../../Dashboard/Charts/DownloadChart";
import html2canvas from "html2canvas";
import { downloadCanvasWithTitle, downloadCSVData, toTitleCase } from "../../../../../Dashboard/Charts/utils";

function CompetitorByEngagement(props) {
    const [showAverage, setShowAverage] = useState(true);
    let filteredData = props.data;
    let competitorAccountList = props.competitorList;

    const widgetContainerRef = useRef();

    useEffect(() => {
        if (props.isCompPage) {
            props.setSelectedCompetitorAccount(competitorAccountList[0]);
        }
    }, [props.selectedCompetitors]);

    if (props.isCompPage) {
        if (props.selectedCompetitors.length > 0) {
            competitorAccountList = competitorAccountList.filter((ac) => props.selectedCompetitors.includes(ac.research_query_id));
        }
    }
    const chartEl = useRef();

    let nodata = filteredData?.data?.nodata && !filteredData?.loading;

    const platformList = {
        facebook: FacebookIcon,
        instagram: InstagramIcon,
        twitter: TwitterIcon,
        tiktok: TiktokIcon,
    };

    // const increment = () => {
    //     if (competitorAccountList.length === 1) return;
    //     let index;
    //     competitorAccountList.map((value, ind) => {
    //         if (value.research_query_id === props.selectedCompetitorAccount?.research_query_id) index = ind;
    //     });
    //     if (index === competitorAccountList.length - 1) props.setSelectedCompetitorAccount(competitorAccountList[0]);
    //     else props.setSelectedCompetitorAccount(competitorAccountList[index + 1]);
    // };

    // const decrement = () => {
    //     if (competitorAccountList.length === 1) return;
    //     let index;
    //     competitorAccountList.map((value, ind) => {
    //         if (value.research_query_id === props.selectedCompetitorAccount?.research_query_id) index = ind;
    //     });
    //     if (index === 0) props.setSelectedCompetitorAccount(competitorAccountList[competitorAccountList.length - 1]);
    //     else props.setSelectedCompetitorAccount(competitorAccountList[index - 1]);
    // };

    const renderDownloadButton = (nodata) => {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: downloadCSV },
                    { name: "PNG", downloadFn: downloadPNG, showLoader: true },
                ]}
            />
        );
    };

    const downloadCSV = () => {
        let data = props.data.data;

        let downLoadingData;
        if (props.selectedCompetitorAccount?.platform === "instagram") {
            downLoadingData = [["Date", "Likes", "Comments", "Total"]];
        } else {
            downLoadingData = [["Date", "Likes", "Comments", "Shares", "Total"]];
        }
        let formatString = "YYYY-MM-DD HH:mm";

        for (let i = 0; i < data.likes_agg.length; i++) {
            let d = [moment(data.likes_agg[i][0]).format(formatString), data.likes_agg[i][1], data.comments_agg[i][1]];

            if (props.selectedCompetitorAccount?.platform === "facebook") {
                d.push(data.shares_agg[i][1]);
            }

            d.push(data.total_agg[i][1]);
            downLoadingData.push(d);
        }

        if (props.selectedCompetitorAccount?.platform === "instagram") downLoadingData.push(["Average Engagement", "", "", data.total_avg]);
        else downLoadingData.push(["Average Engagement", "", "", "", data.total_avg]);

        downloadCSVData(downLoadingData, `${props.widget?.name || "Engagement"}`);
    };

    const downloadPNG = (cb) => {
        if (props.isFreeTierPackage) {
            props.packageUpgradePopup();
            return;
        }

        html2canvas(chartEl.current, { backgroundColor: "white", allowTaint: true, useCORS: true }).then((canvas) => {
            cb && cb();
            downloadCanvasWithTitle(canvas, props.widget?.name || `${props.widget?.name || "Engagement"}`);
        });
    };

    const elements = (
        <>
            <div className="dashboard-widget-container-header skiptranslate">
                <ChartName
                    name={props.widget?.name || "Engagement"}
                    info={
                        props.selectedCompetitorAccount?.platform === "facebook"
                            ? `This graph shows the number of times people have engaged with your posts through likes, comments and shares. The average line shows the average engagement metric value per post for posts that were published for the date range selected.`
                            : `This graph shows the number of times people have engaged with your posts through likes and comments. The average line shows the average engagement metric value per post for posts that were published for the date range selected.`
                    }
                />
                <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                    {!nodata && (
                        <div className="chart-type">
                            <span onClick={() => props.changeGraphType("bar")} className={props.graph_type === "bar" ? "active-chart" : ""}>
                                <Icon name="bar chart" />
                            </span>
                            <span onClick={() => props.changeGraphType("line")} className={props.graph_type === "line" ? "active-chart" : ""}>
                                <Icon name="line chart" />
                            </span>
                        </div>
                    )}
                    {!props.isCompPage && !props.isPublic && !props.isResearchDashboard && (
                        <ChartFilterIcon
                            chartFilterApplied={props.chartFilterApplied}
                            changeShowChartFilterOptions={props.changeChartFilter}
                            widgetListDashboardCurrent={props.widgetListDashboardCurrent}
                            name={props.widget?.name}
                        />
                    )}
                    {(props.isPublic && nodata) || props.isCompPage ? null : (
                        <Popup
                            className="skiptranslate"
                            trigger={
                                props.expandwidget ? (
                                    <MiniMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                ) : (
                                    <MaxiMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                )
                            }
                            inverted
                            content={props.expandwidget ? "Minimize Widget" : "Maximize Widget"}
                            size="mini"
                            position="bottom center"
                            style={{ zIndex: "99999" }}
                        />
                    )}
                    {!props.isPublic && renderDownloadButton(nodata)}
                    <MoreOptions data-html2canvas-ignore="true" className="more-options" onClick={(e) => props.changeShowMoreOptions(e)} />
                </div>
            </div>
            {props.showMoreOptions && (
                <ChartOptionsSidebar
                    data-html2canvas-ignore="true"
                    showMoreOptionsLoc={props.showMoreOptionsLoc}
                    changeShowMoreOptions={props.changeShowMoreOptions}>
                    {!nodata && <CustomCheckBox checked={props.showLegend} onClick={props.changeShowLegend} label="Show Legends" />}
                    {!nodata && <CustomCheckBox checked={props.showGridLines} onClick={props.changeShowGridLines} label="Show Gridlines" />}
                    {!nodata && <CustomCheckBox label="Show Average" checked={showAverage} onClick={() => setShowAverage((val) => !val)} />}
                    {!props.isCompPage && !props.isPublic && !props.isStandardDashboard && !props.isResearchDashboard && (
                        <>
                            <div className="chart-settings menu-option" onClick={props.chartSettings}>
                                <span>Chart Configuration</span>
                                <Settings />
                            </div>
                            <div className="clone-chart menu-option" onClick={props.cloneWidget}>
                                <span>Clone Chart</span>
                                <CloneIcon />
                            </div>
                        </>
                    )}
                    {!nodata && (
                        <FBIntervalSelector aggs_val={props.aggs_val} appliedFilter={props.appliedFilter} handleIntervalChange={props.handleIntervalChange} />
                    )}
                    {!props.isCompPage && !props.isStandardDashboard && !props.isResearchDashboard && !props.isPublic && (
                        <DeleteWidget onClick={props.deleteWidget} />
                    )}
                </ChartOptionsSidebar>
            )}

            <div className="dashboard-chart dashboard-chart-slider skiptranslate" ref={chartEl}>
                {/* <div
                    data-html2canvas-ignore="true"
                    className={`chart-slider chart-slider-left ${props.competitorsAccountList?.length === 1 ? "disabled" : ""}`}>
                    <ArrowIcon onClick={decrement} />
                </div> */}
                <div className="chart-area">
                    {/* {props.selectedCompetitorAccount && (
                        <CompPageSelector
                            selectedCompetitorAccount={props.selectedCompetitorAccount}
                            setSelectedCompetitorAccount={props.setSelectedCompetitorAccount}
                            competitorsAccountList={competitorAccountList}
                            widgetContainerRef={props.widgetContainerRef}
                        />
                    )} */}

                    <div>
                        <p className="competitor__heading">{`${
                            props.currentSelectedCompetitors?.userName ? toTitleCase(props.currentSelectedCompetitors?.userName) : null
                        } (${toTitleCase(props.currentSelectedCompetitors?.platform || "")})`}</p>
                    </div>

                    {!nodata ? (
                        filteredData?.loading ? (
                            <Loading />
                        ) : (
                            props.data.data && (
                                <CompetitorByEngagementChart
                                    widgetContainerRef={props.isCompPage ? widgetContainerRef : props.widgetContainerRef}
                                    data={props.data.data}
                                    isCompPage={props.isCompPage}
                                    showGridLines={props.showGridLines}
                                    showLegend={props.showLegend}
                                    graph_type={props.graph_type}
                                    showAverage={showAverage}
                                    selectedCompetitorAccount={props.selectedCompetitorAccount}
                                />
                            )
                        )
                    ) : (
                        <NoData />
                    )}
                </div>
                {/* <div
                    data-html2canvas-ignore="true"
                    className={`chart-slider chart-slider-right ${props.competitorsAccountList?.length === 1 ? "disabled" : ""}`}>
                    <ArrowIcon onClick={increment} />
                </div> */}
            </div>
        </>
    );

    return props.isCompPage ? (
        <div className={`dashboard-widget-container ${props.expandWidget ? "maximize-widget" : ""}`} ref={widgetContainerRef}>
            {elements}
        </div>
    ) : (
        <>{elements}</>
    );
}

export default CompetitorByEngagement;
